module.exports = __webpack_public_path__ + "static/img/王燕雄董事长2.1689e585.png";